import { css } from 'styled-components';

// @ts-ignore
export const mobile = (inner) => css`
  @media (max-width: ${1000 / 16}em) {
    ${inner};
  }
`;
 

// @ts-ignore
export const phone = (inner) => css`
  @media (max-width: ${650 / 16}em) {
    ${inner};
  }
`;
